import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable'
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination'
import { handlePaginationEntries } from '../../../../utils/pagination'
import { ErrorToast, SuccessToast } from '../../../../utils/toast'
import Loader from '../../../../Components/Loader/Loader'
import './CompletedScheduleReportTableStyle.css'
import CustomConfirmModal from '../../../../Components/custom_components/CustomConfirmModal/CustomConfirmModal'
import { get_all_completed_schedule_reports_with_pagination, schedule_move_to_client, schedule_move_to_finance } from '../../../../config/ScheduleReportApis/scheduleReportApis'
import CompletedScheduleReportSearchFilter from '../CompletedScheduleReportSearchFilter/CompletedScheduleReportSearchFilter'

function CompletedScheduleReportTable() {

    // State variables for managing schedule data, pagination, and modal states
    const [scheduleListing, setScheduleListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });

    const [refresh, setRefresh] = useState(false);

    const [filterValues, setFilterValues] = useState({
        ScheduleCode: '',
        Survey_from_date: '',
        Survey_end_date: '',
        TechnologyId: '',
        WorksiteId: '',
        EquipmentID: '',
        movetoclient: 0,
    }); // Define filter values state
    const [showCheckBox, setShowCheckBox] = useState(filterValues?.movetoclient == 0); //movetoclient =0 means not moved to client

    const [isLoading, setIsLoading] = useState(false); // Loader state
    const [submitModal, setSubmitModal] = useState({
        isOpen: false,
        id: '',
    });
    const [submitToFinance, setSubmitToFinance] = useState({
        isOpen: false,
        id: '',
    });
    const [selectedIds, setSelectedIds] = useState([]); //FOR FORWARD THE SCHEDULES ID INTO FINANCE


    // Fetch schedule data on page change or refresh
    useEffect(() => {
        CompeltedSchedulereports();
    }, [pageNumber, totalItemPerPage, filterValues, refresh]);

    // Fetch schedule data from API
    const CompeltedSchedulereports = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);
     
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_all_completed_schedule_reports_with_pagination(formData);

            if (response?.status === "success") {
                const data = response.data;
                setScheduleListing(data.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setScheduleListing([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Report ", key: "Reportname" },
        { title: "Schedule", key: "ScheduleCode" },
        { title: "Client", key: "Clientname" },
        { title: "Project", key: "Projectname" },
        { title: "Technology ", key: "technologyname" },
        { title: "Worksite", key: "ScheduleWorksite" },
        { title: "From", key: "ReportEndDate" },
        { title: "To", key: "ReportEndDate" },
        { title: "Status", key: "Movetoclient" },

    ]

    // Map the schedule data into table rows
    const rows = () => scheduleListing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        id: item.Report_id,
        Reportname: item.Reportname,
        ScheduleCode: item.ScheduleCode,
        technologyname: item?.Technologyname,
        ScheduleCode: item.ScheduleCode,
        ReportStartDate: item?.ReportStartDate,
        ReportEndDate: item?.ReportEndDate,
        ScheduleWorksite: item.WorksiteName,
        Movetoclient: item?.Movetoclient === `Pending` ? 'Ready for submission' : item?.Movetoclient,
        Clientname: item.ClientName,
        Projectname: item.ProjectName,


    }));


    
    // FOR FORWARD SCHEDULE INTO CLIENT OR FINANCE
    const handleForwardToFinance = async () => {
        const params = {
      
            schedulId: selectedIds, //  submitModal?.id
            move_status: 1
        }

        try {
            const response = await schedule_move_to_finance(params)
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message)
                setRefresh(!refresh)
                setSelectedIds([]) //clear tge selected id after successfull forward
                handlSubmitTofinanceModal(false, "")
            } else {
                ErrorToast(response?.data?.message || `Something Went Wrong!`)
            }
        } catch (error) {

        }

    }
    // reports forward to client
    const handleForwardToClient = async () => {
        const params = {
            reportID: JSON.stringify(selectedIds), //  submitModal?.id
        }
        try {
            const response = await schedule_move_to_client(params)
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message)
                setRefresh(!refresh)
                setSelectedIds([]) //clear tge selected id after successfull forward
                handlSubmitModal(false, "")
            } else {
                ErrorToast(response?.data?.message || `Something Went Wrong!`)
                // }
            }
        } catch (error) {

        }

    }


    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    // Handle search filter changes and update filter values
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
        setShowCheckBox(filterValues?.movetoclient == 0)
    };
    // Function to handle HIDE/SHOW DELETE MODAL
    const handlSubmitModal = (isOpen, id = '') => {
        setSubmitModal({ isOpen, id })
    }

    // Function to handle HIDE/SHOW DELETE MODAL
    const handlSubmitTofinanceModal = (isOpen, id = '') => {
        setSubmitToFinance({ isOpen, id })
    }

    // FOR SELECET ALL FUNCTION
    const handleSelectAll = (isChecked) => {

        if (isChecked) {
            const allIds = rows()?.map((row) => row.id);
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };

    // FOR SELECT SCHEDULE BY ROW
    const handleSelectRow = (id) => {
        setSelectedIds((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((itemId) => itemId !== id)
                : [...prevSelected, id]
        );
    };

    const handleClearSelectedIds = () => {
        setSelectedIds([])
    }


    return (
        <>
            <div className='workforce-management-table-container'>
                <CompletedScheduleReportSearchFilter
                    tableTitle={`Reports`}
                    searchFilter={handleSearchFilter}
                    isSendPermission={selectedIds?.length > 0}
                    handlSubmitModal={handlSubmitModal}
                    handlSubmitTofinanceModal={handlSubmitTofinanceModal}
                    handleClearSelectedIds={handleClearSelectedIds}

                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}

                />
                <div>
                    <CustomTable
                        columns={columns}
                        rows={isLoading ? [] : rows()}
                        isCheckbox={showCheckBox && rows()?.length > 0} //not show the select all check  box when no data
                        selectedIds={selectedIds}
                        handleSelectAll={handleSelectAll}
                        handleSelectRow={handleSelectRow}
                        isLoading={isLoading}
                    />
                </div>
                <div className='bottom-container'>
                    {isLoading ? <Loader /> : <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />}
                </div>
            </div>

            {/* Submit to Finance Department */}
            <CustomConfirmModal
                custom_text={'Want to submit this to the Finance Department?'}
                open_modal={submitToFinance?.isOpen}
                close_modal={handlSubmitTofinanceModal}
                confirm_function={handleForwardToFinance}
            />

            {/* Submit to Reports to client */}
            <CustomConfirmModal
                custom_text={'Want to submit this to the Client?'}
                open_modal={submitModal?.isOpen}
                close_modal={handlSubmitModal}
                confirm_function={handleForwardToClient}
            />
        </>
    )
}

export default CompletedScheduleReportTable